
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecommerce",
      function () {
        return require("private-next-pages/ecommerce.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecommerce"])
      });
    }
  